// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

/** English UI strings: support messages in the staff admin console (routes/AdminSupport.tsx). Merged into the catalog by messages.en.ts. */
export const adminSupport = {
  "admin.tab.support": "Support",
  "admin.support.description": "Messages sent with the contact form on granite.md. Answer by email, then close them.",
  "admin.support.show": "Show",
  "admin.support.filter.open": "Open",
  "admin.support.filter.closed": "Closed",
  "admin.support.filter.all": "All",
  "admin.support.col.topic": "Topic",
  "admin.support.col.from": "From",
  "admin.support.col.message": "Message",
  "admin.support.topic.question": "Question",
  "admin.support.topic.billing": "Billing",
  "admin.support.topic.bug": "Bug",
  "admin.support.topic.account": "Account",
  "admin.support.topic.report": "Report",
  "admin.support.topic.other": "Other",
  "admin.support.status.open": "Open",
  "admin.support.status.closed": "Closed",
  "admin.support.received": "Received {date}",
  "admin.support.closedBy": "Closed {date} by {email}",
  "admin.support.closedAt": "Closed {date}",
  "admin.support.page": "Page",
  "admin.support.sender": "Sent from",
  "admin.support.reply": "Reply by email",
  "admin.support.replySubject": "Re: your Granite support message",
  "admin.support.close": "Close",
  "admin.support.reopen": "Reopen",
  "admin.support.title": "Support message",
} as const;
